import axpost from '@/assets/http'
export default {
    //去掉html标签只留文本
    removeLab(str) {
        return str.replace(/<[^>]+>|&[^>]+;/g, "");
    },
    //限制文本字数
    limitNum(str, num) {
        return str.substr(0, num) + "..."
    },
    //获取当前时间
    getTime() {
        let data = new Date();
        let year = data.getFullYear();
        let month = data.getMonth() + 1;
        let day = data.getDate();
        let hours = data.getHours();
        let minutes = data.getMinutes();
        let seconds = data.getSeconds();
        return year + "-" + (month < 10 ? ("0" + month) : month) + "-" + (day < 10 ? ("0" + day) : day) + " " + (hours < 10 ? ("0" + hours) : hours) + ":" + (minutes < 10 ? ("0" + minutes) : minutes) + ":" + (seconds < 10 ? ("0" + seconds) : seconds)
    },
    //int格式转str
    getString(num) {
        num = num.toString()
        return num
    },
    //缓存行业
    getIndustryDict(data) {
        let timedata2 = new Date()
        let time2 = Date.parse(timedata2);
        if (localStorage.getItem("getIndustryDict")&&time2-Number(localStorage.getItem("getIndustryDictTime"))<86400000) {
            console.log('缓存行业')    
            return JSON.parse(localStorage.getItem("getIndustryDict"))
        } else {
            let backdata = axpost.post("/user/InternalManageService/getIndustryLogistics", data)
                .then(res => {
                    let infordata = res[0];
                    let timedata = new Date()
                    let time = Date.parse(timedata);
                    localStorage.setItem("getIndustryDict", JSON.stringify(infordata));
                    localStorage.setItem("getIndustryDictTime", time);
                    return infordata;
                })
            return backdata;
        }
    },
    //缓存货物类别
    getGoodscateDict(data) {
        let timedata2 = new Date()
        let time2 = Date.parse(timedata2);
        if (localStorage.getItem("getGoodscateDict")&&time2-Number(localStorage.getItem("getGoodscateDictTime"))<86400000) {
                console.log('缓存货物类别')
                return JSON.parse(localStorage.getItem("getGoodscateDict"))
        } else {
            let backdata = axpost.post("/user/InternalManageService/getGoodsCategory", data)
                .then(res => {
                    let infordata = res[0];
                    let timedata = new Date()
                    let time = Date.parse(timedata);
                    localStorage.setItem("getGoodscateDict", JSON.stringify(infordata));
                    localStorage.setItem("getGoodscateDictTime", time);
                    return infordata;
                })
            return backdata;
        }
    },
    //缓存货物类型
    getGoodstypeDict(data) {
        let timedata2 = new Date()
        let time2 = Date.parse(timedata2);
        if (localStorage.getItem("getGoodstypeDict")&&time2-Number(localStorage.getItem("getGoodstypeDictTime"))<86400000) {
                console.log('缓存货物类型')
                return JSON.parse(localStorage.getItem("getGoodstypeDict"))
        } else {
            let backdata = axpost.post("/user/InternalManageService/getGoodsType", data)
                .then(res => {
                    let infordata = res[0];
                    let timedata = new Date()
                    let time = Date.parse(timedata);
                    localStorage.setItem("getGoodstypeDict", JSON.stringify(infordata));
                    localStorage.setItem("getGoodstypeDictTime", time);
                    return infordata;
                })
            return backdata;
        }
    },
    //缓存运输类型
    getTransportDict(data) {
        let timedata2 = new Date()
        let time2 = Date.parse(timedata2);
        if (localStorage.getItem("getTransportDict")&&time2-Number(localStorage.getItem("getTransportDictTime"))<86400000) {
                console.log('缓存运输类型')
                return JSON.parse(localStorage.getItem("getTransportDict"))
        } else {
            let backdata = axpost.post("/user/InternalManageService/getTransportType", data)
                .then(res => {
                    let infordata = res[0];
                    let timedata = new Date()
                    let time = Date.parse(timedata);
                    localStorage.setItem("getTransportDict", JSON.stringify(infordata));
                    localStorage.setItem("getTransportDictTime", time);
                    return infordata;
                })
            return backdata;
        }
    },
    //缓存车型要求
    getCarModelDict(data) {
        let timedata2 = new Date()
        let time2 = Date.parse(timedata2);
        if (localStorage.getItem("getCarModelDict")&&time2-Number(localStorage.getItem("getCarModelDictTime"))<86400000) {
                console.log('缓存车型要求')
                return JSON.parse(localStorage.getItem("getCarModelDict"))
        } else {
            let backdata = axpost.post("/user/InternalManageService/getCarModel", data)
                .then(res => {
                    let infordata = res[0];
                    let timedata = new Date()
                    let time = Date.parse(timedata);
                    localStorage.setItem("getCarModelDict", JSON.stringify(infordata));
                    localStorage.setItem("getCarModelDictTime", time);
                    return infordata;
                })
            return backdata;
        }
    },
    //缓存车长要求
    getCarlongDict(data) {
        let timedata2 = new Date()
        let time2 = Date.parse(timedata2);
        if (localStorage.getItem("getCarlongDict")&&time2-Number(localStorage.getItem("getCarlongDictTime"))<86400000) {
                console.log('缓存车长要求')
                return JSON.parse(localStorage.getItem("getCarlongDict"))
        } else {
            let backdata = axpost.post("/user/InternalManageService/getCarLong", data)
                .then(res => {
                    let infordata = res[0];
                    let timedata = new Date()
                    let time = Date.parse(timedata);
                    localStorage.setItem("getCarlongDict", JSON.stringify(infordata));
                    localStorage.setItem("getCarlongDictTime", time);
                    return infordata;
                })
            return backdata;
        }
    },
    //缓存服务类型-园区
    getParkServiceDict(data) {
        let timedata2 = new Date()
        let time2 = Date.parse(timedata2);
        if (localStorage.getItem("getParkServiceDict")&&time2-Number(localStorage.getItem("getParkServiceDictTime"))<86400000) {
                console.log('缓存服务类型')
                return JSON.parse(localStorage.getItem("getParkServiceDict"))
        } else {
            let backdata = axpost.post("/user/InternalManageService/getParkServiceType", data)
                .then(res => {
                    let infordata = res[0];
                    let timedata = new Date()
                    let time = Date.parse(timedata);
                    localStorage.setItem("getParkServiceDict", JSON.stringify(infordata));
                    localStorage.setItem("getParkServiceDictTime", time);
                    return infordata;
                })
            return backdata;
        }
    },
    //缓存仓储类型
    getStorageTypeDict(data) {
        let timedata2 = new Date()
        let time2 = Date.parse(timedata2);
        if (localStorage.getItem("getStorageTypeDict")&&time2-Number(localStorage.getItem("getStorageTypeDictTime"))<86400000) {
                console.log('缓存仓储类型')
                return JSON.parse(localStorage.getItem("getStorageTypeDict"))
        } else {
            let backdata = axpost.post("/user/InternalManageService/getStorageType", data)
                .then(res => {
                    let infordata = res[0];
                    let timedata = new Date()
                    let time = Date.parse(timedata);
                    localStorage.setItem("getStorageTypeDict", JSON.stringify(infordata));
                    localStorage.setItem("getStorageTypeDictTime", time);
                    return infordata;
                })
            return backdata;
        }
    },
    //缓存建筑标准
    getBuildingStandardDict(data) {
        let timedata2 = new Date()
        let time2 = Date.parse(timedata2);
        if (localStorage.getItem("getBuildingStandardDict")&&time2-Number(localStorage.getItem("getBuildingStandardDictTime"))<86400000) {
                console.log('缓存建筑标准')
                return JSON.parse(localStorage.getItem("getBuildingStandardDict"))
        } else {
            let backdata = axpost.post("/user/InternalManageService/getBuildingStandard", data)
                .then(res => {
                    let infordata = res[0];
                    let timedata = new Date()
                    let time = Date.parse(timedata);
                    localStorage.setItem("getBuildingStandardDict", JSON.stringify(infordata));
                    localStorage.setItem("getBuildingStandardDictTime", time);
                    return infordata;
                })
            return backdata;
        }
    },
    //缓存主体结构-仓储
    getStorageResourcesDict(data) {
        let timedata2 = new Date()
        let time2 = Date.parse(timedata2);
        if (localStorage.getItem("getStorageResourcesDict")&&time2-Number(localStorage.getItem("getStorageResourcesDictTime"))<86400000) {
                console.log('缓存主体结构')
                return JSON.parse(localStorage.getItem("getStorageResourcesDict"))
        } else {
            let backdata = axpost.post("/user/InternalManageService/getStorageResourcesMainStructure", data)
                .then(res => {
                    let infordata = res[0];
                    let timedata = new Date()
                    let time = Date.parse(timedata);
                    localStorage.setItem("getStorageResourcesDict", JSON.stringify(infordata));
                    localStorage.setItem("getStorageResourcesDictTime", time);
                    return infordata;
                })
            return backdata;
        }
    },
    //缓存服务内容-仓储
    getServiceContentDict(data) {
        let timedata2 = new Date()
        let time2 = Date.parse(timedata2);
        if (localStorage.getItem("getServiceContentDict")&&time2-Number(localStorage.getItem("getServiceContentDictTime"))<86400000) {
                console.log('缓存服务内容')
                return JSON.parse(localStorage.getItem("getServiceContentDict"))
        } else {
            let backdata = axpost.post("/user/InternalManageService/getServiceContent", data)
                .then(res => {
                    let infordata = res[0];
                    let timedata = new Date()
                    let time = Date.parse(timedata);
                    localStorage.setItem("getServiceContentDict", JSON.stringify(infordata));
                    localStorage.setItem("getServiceContentDictTime", time);
                    return infordata;
                })
            return backdata;
        }
    },
    //缓存省份
    getProvinceDict(data) {
        let timedata2 = new Date()
        let time2 = Date.parse(timedata2);
        if (localStorage.getItem("getProvinceDict")&&time2-Number(localStorage.getItem("getProvinceDictTime"))<86400000) {
                console.log('缓存省份')
                return JSON.parse(localStorage.getItem("getProvinceDict"))
        } else {
            let backdata = axpost.post("/user/InternalManageService/GetProvince", data)
                .then(res => {
                    let infordata = res[0];
                    let timedata = new Date()
                    let time = Date.parse(timedata);
                    localStorage.setItem("getProvinceDict", JSON.stringify(infordata));
                    localStorage.setItem("getProvinceDictTime", time);
                    return infordata;
                })
            return backdata;
        }
    },
     //缓存省市区
     getProvincesDict(data) {
        let timedata2 = new Date()
        let time2 = Date.parse(timedata2);
        if (localStorage.getItem("getProvincesDict")&&time2-Number(localStorage.getItem("getProvincesDictTime"))<86400000) {
                console.log('缓存省份')
                return JSON.parse(localStorage.getItem("getProvincesDict"))
        } else {
            let backdata = axpost.post("/user/InternalManageService/GetAllAreaNew", data)
                .then(res => {
                    let infordata = res[0];
                    let timedata = new Date()
                    let time = Date.parse(timedata);
                    localStorage.setItem("getProvincesDict", JSON.stringify(infordata));
                    localStorage.setItem("getProvincesDictTime", time);
                    return infordata;
                })
            return backdata;
        }
    }
}


// WEBPACK FOOTER //
// ./src/assets/common.js